// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3C92q","item":"PaymentsMobile_item__e-zWb","label":"PaymentsMobile_label__iOQml","amount":"PaymentsMobile_amount__jK-5l"};